import { globalOnDemandVars } from '../../helper/context'
import { delay } from 'lodash'
import Firestore from '../initFirebase'
import {
  handleErrorInCatch,
  notSavedInAnonymous,
  notSavedInSharing,
  savingEnd,
  savingStart
} from '../../helper/functions'

export async function deleteTreeNode (id, retryCount = 0) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  if (retryCount <= 20) {
    if (retryCount === 0) { savingStart() }
    try {
      await Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('TreeNodes').doc(id).delete()
      savingEnd()
    } catch (e) {
      delay(() => {
        deleteTreeNode(id, retryCount + 1)
      }, 500)
    }
  } else {
    handleErrorInCatch({}, 'deleteData.js')
  }
}
